import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Css/Attendance.css";
import "./Css/Attendance-responsive.css";

import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { InputSwitch } from "primereact/inputswitch";
import { confirmDialog } from "primereact/confirmdialog";

import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import PageLoader from "../../../Components/PageLoader";
import AlertModal from "../../../Components/AlertModal";
import { goToTop } from "../../../Components/goToTop";
import { baseURL } from "../../../Api/ApiConstant";
import { formatDate } from "../../../Utils/getDate";
import { getAppCurrencyType } from "../../../Utils/Common";

import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import {
  getAttendanceByEmployeeList,
  getAttendanceEmployeeList,
  getAttendanceHomeList,
  getAttendanceProjects,
  getAttendanceTakenList,
} from "../../../Controllers/Thunks/HeyTraderThunks";
import {
  AttendanceTakenType,
  mapAttendanceTakenTypes,
} from "../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceTakenType";
import { fetchAllProjects } from "../../../Controllers/Thunks/projectThunks";
import {
  AttendanceProjectType,
} from "../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceProjectType";
import { activeAttendancesEmployee, addAttendances, deleteAttendanceData, getAttendanceByEmployeeServiceBetweenDates, shareProjectAttendance } from "../../../Api/HeyTraderService/AttendanceServices";
import { EmployeeAttendanceType, mapEmployeeAttendanceType } from "../../../Controllers/Types/HeyTraderTypes/Attendances/EmployeeAttendanceType";
import { RootState } from "../../../Controllers/Store";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { AttendanceHomeType } from "../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceHomeType";
import { Project } from "../../../Controllers/Types/Project/ProjectInterface";
import { SiteEmployeeType } from "../../../Controllers/Types/HeyTraderTypes/Attendances/SiteEmployeeType";
import { AttendanceInfoType } from "../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceInfoType";
import { startOfMonth, endOfMonth } from "date-fns";
import { AttendanceSingleEmployeeType } from "../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceSingleEmployeeType";
import SharedByAvatar from "../../../Components/SharedByAvatar";

import { shareProjectClientAccount } from "../../../Api/HeyTraderService/ClientAccountService";
import ShareModal from "../../../Components/ShareModal";

import { mapShareContactType, ShareContactType } from "../../../Controllers/Types/Share/ShareContactType";

const Attendance: React.FC = () => {
  const today = new Date();
  const navigate = useNavigate();
  const location = useLocation();
  const currencySymbol = getAppCurrencyType();

  const loadingPage = useAppSelector((state) => state?.attendanceHome?.loader && state?.attendanceTaken?.loader);
  const attendanceTakenLoading = useAppSelector((state) => state?.attendanceTaken?.loader);
  const tableDataLoading = useAppSelector((state) => state?.attendanceHome?.loader);



  const error = useAppSelector((state) => state?.attendanceHome?.errorDisplay);
  const [loading, setLoading] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const toast = useRef<Toast>(null);

  const [mainProject, setMainProject] = useState<AttendanceProjectType | null>(null);

  const [attendanceData, setAttendanceData] = useState<AttendanceHomeType[]>([]);
  const [finalattendanceData, setFinalAttendanceData] = useState<AttendanceTakenType[]>([]);

  const [filteredAttendanceData, setFilteredAttendanceData] = useState<AttendanceHomeType[]>([]);
  const [selectedAttendanceData, setSelectedAttendanceData] = useState<AttendanceHomeType | null>(null);
  const [showAttendanceModal, setShowAttendanceModal] = useState<boolean>(false);

  const [dateFilter, setDateFilter] = useState<Nullable<Date>>();
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [sitesOptionData, setSitesOptionData] = useState<AttendanceProjectType[]>([]);
  const [siteFilter, setSiteFilter] = useState<AttendanceProjectType | null>(null);
  const [selectedSiteId, setSelectedSiteId] = useState<number | null>(null);
  const [initalLoading, setInitalLoading] = useState<boolean>(true);
  const [attendanceAdded, setAttendanceAdded] = useState<boolean>(false);
  const [employeeSearchKey, setEmployeeSearchKey] = useState<string>("");
  const [presentCount, setPresentCount] = useState<number>(0);
  const [absentCount, setAbsentCount] = useState<number>(0);
  const [halfdayCount, setHalfdayCount] = useState<number>(0);
  const [totalPay, setTotalPay] = useState<number>(0);

  const [sitesData, setSitesData] = useState<AttendanceProjectType[]>([]);

  const [filteredSitesData, setFilteredSitesData] = useState<AttendanceProjectType[]>([]);
  const [showSiteModal, setShowSiteModal] = useState<boolean>(false);
  const [siteSearchKey, setSiteSearchKey] = useState<string>("");

  const [attendanceDate, setAttendanceDate] = useState<Nullable<Date>>(null);
  const [selectedAttendanceDate, setSelectedAttendanceDate] = useState<string>("");

  const [filteredSiteEmployeesData, setFilteredSiteEmployeesData] = useState<AttendanceTakenType[]>([]);
  const [attendanceSearchkey, setAttendanceSearchKey] = useState<string>("");
  const [employeeSiteData, setEmployeeSiteData] = useState<{ [key: number]: AttendanceProjectType | null; }>({});
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(null);
  const [employeeAttendance, setEmployeeAttendance] = useState<{ [key: number]: "Present" | "Absent" | "Halfday" | null; }>({});

  const [showAttendanceViewModal, setShowAttendanceViewModal] = useState<boolean>(false);
  const [employeeSiteFilter, setEmployeeSiteFilter] = useState<AttendanceProjectType | null>(null);
  const [selectedEmployeeSiteId, setSelectedEmployeeSiteId] = useState<number | null>(null);
  const [selectedAttendanceEmployeeSiteId, setSelectedAttendanceEmployeeSiteId] = useState<number | null>(null);

  // const currentMonth = new Date().toISOString().slice(0, 7);
  const currentMonth = new Date();
  const [viewDate, setViewDate] = useState<Date>(currentMonth);
  const [employeeAttendanceData, setEmployeeAttendanceData] = useState<EmployeeAttendanceType | null>(null);
  const [employeeAttendanceDate, setEmployeeAttendanceDate] = useState<Nullable<Date>>(null);
  const [highlightedDates, setHighlightedDates] = useState<Record<string, string>>({});

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');


  const [showEmployeeListModal, setShowEmployeeListModal] = useState<boolean>(false);
  const [employeeListSearchKey, setEmployeeListSearchKey] = useState<string>("");
  const [siteEmployeesData, setSiteEmployeesData] = useState<SiteEmployeeType[]>([]);

  const [isUseLastAttendanceRecord, setIsUseLastAttendanceRecord] = useState<boolean>(true);

  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
  const [paymentSiteFilter, setPaymentSiteFilter] = useState<AttendanceProjectType | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(startOfMonth(new Date()));
  const [endDate, setEndDate] = useState<Date | null>(endOfMonth(new Date()));

  const [diplayPayment, setDisplayPayment] = useState<EmployeeAttendanceType | null>(null);
  const [pamentViewLoading, setPamentViewLoading] = useState<boolean>(false);
  const [displayPresentValue, setDisplayPresentValue] = useState<number | null>(null);
  const [displayAbsentValue, setDisplayAbsentValue] = useState<number | null>(null);
  const [displayHalfDayValue, setDisplayHalfDayValue] = useState<number | null>(null);
  const [displayTotalPayValue, setDisplayTotalPayValue] = useState<number | null>(null);

  // share
  const [showContactShareModal, setShowContactShareModal] = useState<boolean>(false);
  const [sharedList, setSharedList] = useState<ShareContactType[]>([]);
  const [projectContactIds, setProjectContactIds] = useState<number[]>([]);
  const [shareProjectIds, setShareProjectIds] = useState<number[]>([]);


  const siteEmployeeList = useAppSelector((state) => state.attendanceEmployees.attendanceEmployeeList);
  const loadingEmployeeList = useAppSelector((state) => state?.attendanceEmployees?.loader);

  useEffect(() => {
    const fetchData = async () => {
      if (siteEmployeeList && siteEmployeeList?.length > 0) {

        const filteredData = (employeeListSearchKey && employeeListSearchKey != null) ? siteEmployeeList.filter((employee) => employee?.personalInfo?.first_name!.toLowerCase().includes(employeeListSearchKey.toLowerCase())) : siteEmployeeList;

        //   ||
        // employee?.personalInfo
        //   ?.last_name!.toLowerCase()
        //   .includes(employeeListSearchKey.toLowerCase())


        setSiteEmployeesData(filteredData);
      } else {
        setSiteEmployeesData([]);
      }
    };
    fetchData();
  }, [siteEmployeeList, employeeListSearchKey]);




  const handleShowAlertModal = () => {
    setShowAlertModal(true);
  }

  const handleCloseAlertModal = () => {
    setShowAlertModal(false);
    setAlertMessage('');
  }

  // need to tigger today attendance list as well.
  const [valueChanged, setValueChanged] = useState<boolean>(false);

  // for the resons
  const dispatch = useAppDispatch();

  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const add_data = useCanEdit("Attendance", "add_attendance");
  const edit_data = useCanEdit("Attendance", "edit_attendance");
  const add_employee = useCanEdit("Attendance", "add_employee");

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(getAttendanceHomeList(formatDate(today)));
    dispatch(getAttendanceTakenList(formatDate(today)));
    dispatch(getAttendanceEmployeeList());
    dispatch(getAttendanceProjects());
    setInitalLoading(false);
  }, []);

  // this is get data from state list and set projectlist
  const attendanceTakenList = useAppSelector((state) => state.attendanceTaken.attendanceTakenList);

  const atteendanceHomeList = useAppSelector((state) => state.attendanceHome.attendanceHomeList);

  // get all projects
  const projectList = useAppSelector((state) => state.attendanceProjects.attendanceProjectList);


  useEffect(() => {
    if (!projectList?.length) return;

    const ids = projectList
      .filter((item) => item.shared_by != null) // checks null & undefined
      .map((item) => item.project_id as number);

    setShareProjectIds(ids);
  }, [projectList]);




  //   convet and add to attendance project list ass well
  useEffect(() => {
    if (projectList && projectList.length > 0) {
      setSitesData([]);
      const list: AttendanceProjectType[] = [];

      const allSitesOption: AttendanceProjectType = {
        project_id: 0,
        job_number: "",
        description: "All sites(My projects)",
        address: "All sites",
        shared_by: null,
        full_address: "All sites-my projects",
        share_list: []
      };

      const allSitesOptionShare: AttendanceProjectType = {
        project_id: -1,
        job_number: "",
        description: "All sites(Share projects)",
        address: "All sites share",
        shared_by: null,
        full_address: "All sites-share projects",
        share_list: []
      };

      list[0] = allSitesOption;
      list[1] = allSitesOptionShare;

      // setSitesData(list);

      // const GettedprojectList: any = projectList?.map((element) => {
      //   return {
      //     project_id: element.project_id,
      //     job_number: element.job_number,
      //     project_type: element.project_type,
      //     description: element.description,
      //     address: element.address,
      //     post_code: element.post_code,
      //     full_address: element.address + " " + element.post_code,
      //   };
      // });
      // setSitesData([
      //   allSitesOption,
      //   ...mapAttendanceProjectTypes(GettedprojectList),
      // ]);

      setSitesData([
        ...list,
        ...projectList,
      ]);
      //  setSitesData([
      //   allSitesOption,
      //   ...projectList,
      // ]);

    }
  }, [projectList]);





  // attendance projec list load.
  useEffect(() => {
    if (location.state && location?.state?.mainProject) {
      const mainproject = location?.state?.mainProject as Project;
      const findlist = sitesData.filter(
        (e) => e.project_id === mainproject.project_id
      );
      if (findlist && findlist.length > 0) {
        setMainProject(findlist[0]);
        setSiteFilter(findlist[0]);
      } else {
        setMainProject(null);
      }
    } else {
      setMainProject(null);
    }
  }, [location?.state, projectList, sitesData]);






  useEffect(() => {
    if (sitesData && sitesData.length > 0) {

      // filter only my projects and all projects
      const data = sitesData.filter((r) => (r.address?.toLowerCase() !== "all sites share") &&
        !shareProjectIds.includes(r?.project_id ?? -3));

      // setSitesOptionData(data);
      setSitesOptionData(sitesData);
    }
  }, [sitesData]);


  useEffect(() => {
    if (siteFilter?.contact?.length) {
      const ids = siteFilter.contact.map((e) => e.id);
      setProjectContactIds(ids);
    } else {
      setProjectContactIds([]);

    }
  }, [siteFilter]);

  // share project ids list



  // set attendance data with added attendances
  useEffect(() => {

    const fetchAttendanceInitialData = async () => {

      // need to divide to diff all types

      if (siteFilter?.address?.toLowerCase() === "all sites") {

        // // all site
        //   const initialAttendanceData = atteendanceHomeList?.filter(
        //   (attendance) =>( attendance?.attendance_date === selectedDate) 
        // );


        const initialAttendanceData = atteendanceHomeList
          ?.filter(
            (attendance) =>
              attendance?.attendance_date === selectedDate &&
              !shareProjectIds.includes(attendance?.project_id ?? -1)
          ) ?? [];



        setAttendanceData(initialAttendanceData);
      } else if (siteFilter?.address?.toLowerCase() === "all sites share") {

        const initialAttendanceData = atteendanceHomeList
          ?.filter(
            (attendance) =>
              attendance?.attendance_date === selectedDate &&
              shareProjectIds.includes(attendance?.project_id ?? -1)
          ) ?? [];



        setAttendanceData(initialAttendanceData);

      } else {
        const initialAttendanceData = atteendanceHomeList
          ?.filter(
            (attendance) =>
              attendance?.attendance_date === selectedDate
          ) ?? [];

        setAttendanceData(initialAttendanceData);
      }
    };


    fetchAttendanceInitialData();

  }, [dateFilter, selectedDate, atteendanceHomeList, attendanceDate, siteFilter]);


  const handleChangeUseLastAttendanceRecord = (e: CheckboxChangeEvent) => {
    setIsUseLastAttendanceRecord(!isUseLastAttendanceRecord);
  }

  // refill shared list data
  useEffect(() => {
    if (!siteFilter) return;
    setSharedList([]); // clear if no share list
    const shareList = siteFilter.share_list ?? [];
    if (shareList.length > 0) {
      const results: ShareContactType[] = shareList.map((e) => {
        const dt: Partial<ShareContactType> = {
          id: e.id,
          first_name: e.first_name,
          last_name: e.last_name!,
          profile_image: e.profile_image,
          email: e.email!,
          type: e.main_type!,
          by: e.by,
          can_edit: e.can_edit,
          can_view: 1, // forcing as "viewable"
        };

        return mapShareContactType(dt);
      });

      setSharedList(results);


    } else {
      setSharedList([]); // clear if no share list
    }
  }, [siteFilter]);

  // set final attendance taken list with last update date.
  useEffect(() => {

    let options: boolean = true;

    if (siteFilter?.address?.toLowerCase() === "all sites") {
      // all site condition applay
      options = attendanceTakenList.filter((e) => e.attendanceData === null).length > 0;

    } else {
      // selected projects
      const count = attendanceTakenList.filter((e) => e.attendanceData?.project_id === siteFilter?.project_id).length;
      if (count == 0 || count > 0) {
        options = false;
      } else {
        options = true;
      }

    }



    //  options =
    //  (siteFilter?.address?.toLowerCase() === "all sites") 
    //  ? attendanceTakenList.filter((e) => e.attendanceData === null).length > 0 : 
    //  attendanceTakenList.filter((e) => (e.attendanceData === null) ? true : (e.attendanceData?.project_id === siteFilter?.project_id)).length > 0;

    setAttendanceAdded(options);
    setValueChanged(options)

    // for share details
    const filtetTakenListShare = attendanceTakenList
      ?.filter(
        (attendance) => (attendance.attendanceData !== null) ? !shareProjectIds.includes(attendance.attendanceData?.project_id ?? -1) : !shareProjectIds.includes(attendance.lastAttendanceData?.project_id ?? -1)
      ) ?? [];

    // filterproject list
    const selectedProjectAttendance = (siteFilter && siteFilter?.address!.toLowerCase() === "all sites") ? filtetTakenListShare : filtetTakenListShare.filter((e) => (e.attendanceData !== null) ? (e.attendanceData?.project_id === siteFilter?.project_id) : (e.lastAttendanceData?.project_id === siteFilter?.project_id))

    let finalDataCollection: any = [];
    if (mainProject !== null) {
      // only project attendance should be checked



      finalDataCollection = selectedProjectAttendance
        .filter(
          (e) =>
            e.lastAttendanceData?.project_id === mainProject.project_id ||
            e.attendanceData?.project_id === mainProject.project_id
        )
        ?.map((element) => {
          if (element.lastAttendanceData !== null) {

            return {
              id: element.id,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              daily_hours: element.daily_hours,
              status: element.status,
              attendanceData: (element.attendanceData === null && isUseLastAttendanceRecord === true) ? element.lastAttendanceData : element.attendanceData,
              lastAttendanceData: element.lastAttendanceData,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };
          } else {

            const attendance: any = {
              id: 0,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              project_id: mainProject.project_id,
              attendance_date: formatDate(attendanceDate!),
              status: element.status,
              project_data: mainProject,
            }

            return {
              id: element.id,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              daily_hours: element.daily_hours,
              status: element.status,
              attendanceData: (element.attendanceData === null && isUseLastAttendanceRecord === true) ? attendance : element.attendanceData,
              lastAttendanceData: element.lastAttendanceData,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };
          }
        });
      // her need to add logic about if the project dosent have eny past attendance data

      const colect = mapAttendanceTakenTypes(finalDataCollection);

      if (colect && colect.length === 0) {
        // need to prepare list with employee details.

        // need skipe ids
        const filterEmp = attendanceTakenList.filter((e) => e.attendanceData != null);

        let prepare: any = [];
        siteEmployeeList.filter((e) => e.attenanceEmployee?.status === 1).forEach(element => {

          if (filterEmp.filter((e) => e.personal_info_id === element.personalInfo?.id).length === 0) {

            const attendance: any = {
              id: 0,
              contact_id: element.attenanceEmployee?.contact_id,
              personal_info_id: element.personalInfo?.id,
              project_id: mainProject.project_id,
              attendance_date: formatDate(attendanceDate!),
              status: null,
              project_data: mainProject,
            }

            const attendanceCont: any = {
              id: 0,
              contact_id: element.attenanceEmployee?.contact_id,
              personal_info_id: element.personalInfo?.id,
              daily_hours: element.attenanceEmployee?.daily_hours,
              status: null,
              attendanceData: attendance,
              lastAttendanceData: null,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };

            prepare.push(attendanceCont);
          }

        });




        //  very beguning data update
        setFinalAttendanceData(mapAttendanceTakenTypes(prepare));

      } else {
        setFinalAttendanceData(mapAttendanceTakenTypes(finalDataCollection));
      }



    } else {
      // all attendance checked
      finalDataCollection = selectedProjectAttendance?.map((element) => {
        return {
          id: element.id,
          contact_id: element.contact_id,
          personal_info_id: element.personal_info_id,
          daily_hours: element.daily_hours,
          status: element.status,
          attendanceData: (element.attendanceData === null && isUseLastAttendanceRecord === true) ? element.lastAttendanceData : element.attendanceData,
          lastAttendanceData: element.lastAttendanceData,
          personalInfo: element.personalInfo,
          userRoleInfo: element.userRoleInfo,
        };
      });



      const colect = mapAttendanceTakenTypes(finalDataCollection);
      const filterEmp = attendanceTakenList.filter((e) => e.attendanceData != null);

      if (colect && colect.length === 0) {
        // need to prepare list with employee details.
        let prepare: any = [];
        siteEmployeeList.filter((e) => e.attenanceEmployee?.status === 1).forEach(element => {

          if (filterEmp.filter((e) => e.personal_info_id === element.personalInfo?.id).length === 0) {

            const attendance: any = {
              id: 0,
              contact_id: element.attenanceEmployee?.contact_id,
              personal_info_id: element.personalInfo?.id,
              project_id: null,
              attendance_date: formatDate(attendanceDate!),
              status: null,
              project_data: null,
            }

            const attendanceCont: any = {
              id: 0,
              contact_id: element.attenanceEmployee?.contact_id,
              personal_info_id: element.personalInfo?.id,
              daily_hours: element.attenanceEmployee?.daily_hours,
              status: null,
              attendanceData: attendance,
              lastAttendanceData: null,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };

            prepare.push(attendanceCont);
          }


        });

        //  very beguning data update
        setFinalAttendanceData(mapAttendanceTakenTypes(prepare));

      } else {
        setFinalAttendanceData(mapAttendanceTakenTypes(finalDataCollection));
      }







    }







    // setFilteredSiteEmployeesData(finalDataCollection);vattendanceTakenList,
  }, [attendanceTakenList, attendanceDate, selectedDate, mainProject, isUseLastAttendanceRecord, siteFilter]);



  useEffect(() => {
    setDateFilter(today);
    setSelectedDate(formatDate(today));
    setAttendanceDate(today);
    setSelectedAttendanceDate(formatDate(today));
  }, []);

  useEffect(() => {
    if (mainProject !== null) {
      setSiteFilter(mainProject);
      setSelectedSiteId(mainProject?.project_id || null);
      setEmployeeSiteFilter(mainProject);
      setSelectedEmployeeSiteId(mainProject?.project_id || null);
    } else {
      setSiteFilter(sitesOptionData[0]);
      setSelectedSiteId(sitesOptionData[0]?.project_id || null);

      setEmployeeSiteFilter(sitesOptionData[0]);
      setSelectedEmployeeSiteId(sitesOptionData[0]?.project_id || null);
    }
  }, [sitesOptionData, mainProject]);







  useEffect(() => {
    const fetchSiteEmployeesData = async () => {
      if (finalattendanceData) {
        const filteredData = finalattendanceData?.filter(
          (employee) =>
            employee?.personalInfo?.first_name
              ?.toLowerCase()
              .includes(attendanceSearchkey.toLowerCase()) ||
            employee?.personalInfo?.last_name
              ?.toLowerCase()
              .includes(attendanceSearchkey.toLowerCase())
        );
        setFilteredSiteEmployeesData(filteredData);
      } else {
        setFilteredSiteEmployeesData([]);
      }
    };
    fetchSiteEmployeesData();
  }, [finalattendanceData, attendanceSearchkey]);




  useEffect(() => {
    const fetchAttendanceData = async () => {
      if (attendanceData) {
        let filteredData: AttendanceHomeType[] = attendanceData;
        if (selectedSiteId === null) {
          filteredData = attendanceData
        }
        else if (selectedSiteId !== 0 && selectedSiteId !== -1) {
          filteredData = filteredData?.filter(
            (attendance) => attendance?.project_id === selectedSiteId
          );
        } else {
          filteredData = attendanceData
        }

        if (employeeSearchKey !== "") {
          filteredData = filteredData?.filter(
            (attendance) =>
              attendance?.personalInfo?.first_name
                ?.toLowerCase()
                .includes(employeeSearchKey.toLowerCase()) ||
              attendance?.personalInfo?.last_name
                ?.toLowerCase()
                .includes(employeeSearchKey.toLowerCase())
          );
        }

        setFilteredAttendanceData(filteredData);
      }
    };

    fetchAttendanceData();
  }, [attendanceData, siteFilter, selectedSiteId, employeeSearchKey]);

  useEffect(() => {
    const fetchSummaryData = async () => {
      if (filteredAttendanceData) {
        const countForPresent = filteredAttendanceData?.filter(
          (attendance) => attendance?.status === "Present"
        )?.length;
        const countForAbsent = filteredAttendanceData?.filter(
          (attendance) => attendance?.status === "Absent"
        )?.length;
        const countForHalfday = filteredAttendanceData?.filter(
          (attendance) => attendance?.status === "Halfday"
        )?.length;
        const totalPay = filteredAttendanceData?.reduce(
          (sum, attendance) => sum + (attendance?.payed ?? 0),
          0
        );

        setPresentCount(countForPresent);
        setAbsentCount(countForAbsent);
        setHalfdayCount(countForHalfday);
        setTotalPay(totalPay);
      } else {
        setPresentCount(0);
        setAbsentCount(0);
        setHalfdayCount(0);
        setTotalPay(0);
      }
    };
    fetchSummaryData();
  }, [filteredAttendanceData]);


  // share function

  /* Share  */
  const handleCloseShareModal = () => {
    setShowContactShareModal(false);
  }

  const handleShareQuotation = () => {
    setShowContactShareModal(true);
    // setSelectedProject(project);
  }

  // database function
  const shareDataFunction = async (selectedContacts: ShareContactType[]) => {
    try {
      // get only ticked data as well
      const sendData = selectedContacts.filter((e) => e.can_view != 0 || e.can_edit != 0)
      if (sendData && sendData?.length > 0) {
        const data = await shareProjectAttendance(
          sendData,
          siteFilter?.project_id!

        );
        if (data.statusCode === 200) {
          setLoading(false);
          handleCloseShareModal();
          dispatch(getAttendanceProjects());

          if (toast.current) {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Attendance shared successfully.',
              life: 3000
            });
          }
        }
      }

    } catch (error) {
      setLoading(false);

      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Failed',
          detail: 'There was an error sharing the quotation.',
          life: 3000
        });
      }
    }
  }
  /*  */








  /* *********************************** Site ********************************** */
  useEffect(() => {
    if (sitesData && sitesData?.length > 0) {
      const filteredSites = sitesData.filter((r) => (r.address?.toLowerCase() !== "all sites share") &&
        !shareProjectIds.includes(r?.project_id ?? -3)).filter(
          (site) =>
            (site
              ?.job_number!.toLowerCase()
              .includes(siteSearchKey.toLowerCase()) ||
              site
                ?.address!.toLowerCase()
                .includes(siteSearchKey.toLowerCase())) &&
            site.project_id !== 0
        );
      setFilteredSitesData(filteredSites);
    } else {
      setFilteredSitesData([]);
    }
  }, [sitesData, siteSearchKey]);

  const handleCloseSiteModal = () => {
    setShowSiteModal(false);
    setSiteSearchKey("");
  };

  const handleChangeSite = (employeeId: number, siteId: number | null) => {
    setSelectedEmployeeId(employeeId);
    setValueChanged(true);
    // site data set
    setShowSiteModal(true);

    setSelectedAttendanceEmployeeSiteId(siteId || null);
  };

  const handleSelectSite = (site: AttendanceProjectType) => {
    if (selectedEmployeeId !== null) {
      // find selected employee id attendance data.
      const selectedlist = finalattendanceData.filter(
        (e) => e.contact_id === selectedEmployeeId
      );

      if (selectedlist && selectedlist.length > 0) {
        const selectAttendance = selectedlist[0].attendanceData; // attendance info type data

        // this is modify attendance data.

        const attendanceDatax: any = {
          id: selectAttendance?.id,
          contact_id: selectedEmployeeId,
          personal_info_id: selectAttendance?.personal_info_id,
          project_id: site.project_id,
          attendance_date: formatDate(attendanceDate!),
          status: selectAttendance?.status,
          project_data: site,
        };

        const finalDataCollection: any = finalattendanceData?.map((element) => {
          if (selectedEmployeeId === element.contact_id) {
            return {
              id: element.id,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              daily_hours: element.daily_hours,
              status: element.status,
              attendanceData: attendanceDatax,
              lastAttendanceData: element.lastAttendanceData,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };
          } else {
            return {
              id: element.id,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              daily_hours: element.daily_hours,
              status: element.status,
              attendanceData: element.attendanceData,
              lastAttendanceData: element.lastAttendanceData,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };
          }
        });
        setFinalAttendanceData(mapAttendanceTakenTypes(finalDataCollection));
      }
    }
    setTimeout(() => handleCloseSiteModal(), 200);
  };
  /* *************************************************************************** */


  /* ***************************** Attendance ***************************** */
  /* For home filter attendance data main actions  */
  const handleFilterDate = (e: any) => {
    const date = e.value;
    setDateFilter(date || null);
    setAttendanceDate(date || null);
    setSelectedDate(formatDate(date));

    setSelectedAttendanceDate(formatDate(date));
    dispatch(getAttendanceHomeList(formatDate(date)));
    dispatch(getAttendanceTakenList(formatDate(date)));
  };

  const projectAddressOptionTemplate = (option: AttendanceProjectType) => {
    return (
      <div className="attendance_project_filter_item">
        <div>{option?.job_number && option.address?.toLowerCase() !== 'all sites' ? option.job_number + ': ' : ''}{option.full_address}</div>

        <React.Fragment>
          {(option.shared_by !== null) && (
            <SharedByAvatar
              // avatarKey={1}
              // firstName={"dinesh"}
              // lastName="hurai"
              // profileImage={null} 
              className="mx-0 small"
              showTooltip={true}
              avatarKey={option?.shared_by?.id}
              firstName={option?.shared_by?.first_name}
              lastName={option?.shared_by?.last_name}
              profileImage={option?.shared_by?.profile_image}
            />
          )}
        </React.Fragment>
      </div>
    );
  };

  const handleFilterProject = (e: DropdownChangeEvent) => {
    const selectedSite = e.value as AttendanceProjectType;
    setSelectedSiteId(selectedSite?.project_id || null);
    setSiteFilter(selectedSite);
  };
  /*  */

  /* For take attendance filter */
  const handleDateChange = (e: any) => {
    const date = e.value;
    setAttendanceDate(date || null);
    setSelectedAttendanceDate(formatDate(date));
    setDateFilter(date || null);
    setSelectedDate(formatDate(date));

    dispatch(getAttendanceTakenList(formatDate(date)));
    dispatch(getAttendanceHomeList(formatDate(date)));
  };
  /*  */

  const handleCloseAttendanceModal = () => {
    setShowAttendanceModal(false);
    handleClearAttendanceFields();
  };

  const handleClearAttendanceFields = () => {
    setAttendanceSearchKey("");
    setEmployeeSiteData({});
    setSelectedEmployeeId(null);
    setValueChanged(false);
    setEmployeeAttendance({});
  };

  const handleAddAttendance = () => {
    setShowAttendanceModal(true);
  };

  //add attendance function here.
  const handleTakeAttendance = async (e: React.FormEvent) => {
    e.preventDefault();

    if (finalattendanceData && finalattendanceData.length > 0) {
      setLoading(true);
      const data = await addAttendances(
        formatDate(attendanceDate!),
        finalattendanceData
      );
      setLoading(false);

      if (data.statusCode === 200) {
        // call shop dispach event
        dispatch(getAttendanceTakenList(formatDate(attendanceDate!)));
        dispatch(getAttendanceHomeList(formatDate(attendanceDate!)));

        setLoading(false);
        setSuccessMessage("Attendance added successfully.");
        handleCloseAttendanceModal();

        setShowAlert(true);
        setTimeout(() => {
          setSuccessMessage("");
          setShowAlert(false);
        }, 2000);
      } else if (data.statusCode === 422) {
        handleShowAlertModal();
        setAlertMessage(`Make sure all employee attendance is recorded.`);
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error adding the attendance.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleNavigateEmployees = () => {
    navigate(`site-employees`, { state: { mainProject: mainProject !== null ? mainProject : null } });
    goToTop();
  };



  const attendanceModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        {attendanceData?.length > 0 ? 'Edit' : 'Take'} attendance

        {siteFilter && (
          <React.Fragment>
            <br />
            <small className="modal_sub_title text-capitalize">{siteFilter?.address}</small>
          </React.Fragment>
        )}
      </h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseAttendanceModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const attendanceModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseAttendanceModal}
      />
      {((attendanceAdded === true && add_data) || (attendanceAdded === false && edit_data)) && (
        <Button
          label={`${loading ? "Processing" : attendanceAdded === false ? "Update" : "Save"}`}
          onClick={handleTakeAttendance}
          loading={loading}
          className="custom_btn primary"
          disabled={attendanceData?.length > 0 && !valueChanged}
        />
      )}
    </div>
  );

  const handleRemoveEmployeeAndAttendance = (newStatus: boolean, employee: AttendanceTakenType) => {
    const currentDate = formatDate(attendanceDate!);

    confirmDialog({
      message: "Do you want to remove this employee from this attendance list?",
      header: "Confirm Status Change",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      dismissableMask: true,
      resizable: false,
      draggable: false,
      accept: () => removeEmployeeAndAttendance(employee),
    });
  };

  const removeEmployeeAndAttendance = async (data: AttendanceTakenType) => {
    const employeeId: number = data?.id || 0;
    const personalInfoId: number = data?.personal_info_id || 0;
    const dateOfAttendance: string = data?.attendanceData?.attendance_date || '';
    const attendanceInfo: AttendanceInfoType | null = data?.attendanceData || null;
    const currentDate = formatDate(attendanceDate!);

    const employeeRemoveResult = await activeAttendancesEmployee(employeeId);

    if (employeeRemoveResult.statusCode === 200) {
      dispatch(getAttendanceEmployeeList());
      dispatch(getAttendanceTakenList(formatDate(attendanceDate!)));
      dispatch(getAttendanceHomeList(formatDate(attendanceDate!)));

      if (dateOfAttendance === currentDate) {
        const attendanceRemoveResult = await deleteAttendanceData(personalInfoId, dateOfAttendance);

        if (attendanceRemoveResult.statusCode === 200) {
          dispatch(getAttendanceEmployeeList());
          dispatch(getAttendanceTakenList(formatDate(attendanceDate!)));
          dispatch(getAttendanceHomeList(formatDate(attendanceDate!)));

          if (toast.current) {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: `This employee and attendance record for ${attendanceDate ? formatDate(attendanceDate) : ''} were successfully removed.`,
              life: 3000,
            });
          }
        } else {

          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: `There was an error removing the employee from the list.`,
              life: 3000,
            });
          }
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "This employee was successfully removed from the attendance list.",
            life: 3000,
          });
        }
      }

    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: `There was an error removing the employee from the list.`,
          life: 3000,
        });
      }
    }
  }

  const handleShowSiteEmployeeList = () => {
    setShowEmployeeListModal(true);
  }

  const handleCloseSiteEmployeeListModal = () => {
    setShowEmployeeListModal(false);
  }

  const siteEmployeeListModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Site Employees</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseSiteEmployeeListModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const siteEmployeeListModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseSiteEmployeeListModal}
      />
    </div>
  );

  const handleModifySiteEmpoyeeList = (newStatus: boolean, employee: SiteEmployeeType) => {
    confirmDialog({
      message: "Do you want to remove this employee from this attendance list??",
      header: "Confirm Status Change",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      dismissableMask: true,
      resizable: false,
      draggable: false,
      accept: () => modifySiteEmpoyeeList(employee?.attenanceEmployee?.id!),
    });
  }

  const modifySiteEmpoyeeList = async (employeeId: number) => {
    const result = await activeAttendancesEmployee(
      employeeId!
    );

    if (result.statusCode === 200) {
      handleCloseSiteEmployeeListModal();

      dispatch(getAttendanceEmployeeList());
      dispatch(getAttendanceTakenList(formatDate(attendanceDate!)));
      // dispatch(getAttendanceHomeList(formatDate(attendanceDate!)));

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Employee successfully added/removed from attendance list.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: `An error occurred while adding/removing the employee from the list.`,
          life: 3000,
        });
      }
    }
  }

  const employeeStatusBody = (rowData: SiteEmployeeType) => {
    return (
      <div className="input_switch_area">
        <InputSwitch
          checked={rowData?.attenanceEmployee?.status === 1}
          onChange={(e) => handleModifySiteEmpoyeeList(e.value, rowData)}
        />
      </div>
    );
  };

  const siteEmployeeNameBody = (rowData: SiteEmployeeType) => {
    const firstName = rowData?.personalInfo?.first_name
      ? rowData?.personalInfo?.first_name
      : "";
    const lastName = rowData?.personalInfo?.last_name
      ? rowData?.personalInfo?.last_name
      : "";

    return (
      <span className="text_bold text-capitalize">
        {firstName + " " + lastName}
      </span>
    );
  };

  const handleCloseAttendanceViewModal = () => {
    setShowAttendanceViewModal(false);
    setSelectedAttendanceData(null);
  };

  // tigger when the user and month chnaged
  useEffect(() => {
    if (selectedAttendanceData !== null) {
      const datemonth: string =
        viewDate.getFullYear() +
        "-" +
        String(viewDate.getMonth() + 1).padStart(2, "0");
      const inputs: string[] = [
        String(selectedAttendanceData?.personal_info_id),
        datemonth,
      ];
      dispatch(getAttendanceByEmployeeList(inputs));
    }
  }, [selectedAttendanceData, viewDate]);


  const handleDeleteAttendance = (data: AttendanceHomeType) => {
    const dateOfAttendance = data?.attendance_date;
    const employeeName = (data?.personalInfo?.first_name + (data?.personalInfo?.last_name ? (' ' + data?.personalInfo?.last_name) : ''))

    confirmDialog({
      message: `Are you sure? Do you want to delete this attendance record for ${employeeName} on ${dateOfAttendance}?`,
      header: "Confirm Delete Attendance",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      dismissableMask: true,
      resizable: false,
      draggable: false,
      acceptClassName: 'p-button-danger',
      accept: () => deleteAttendance(data),
    });
  };

  const deleteAttendance = async (data: AttendanceHomeType) => {
    const personalInfoId: number = data?.personal_info_id || 0;
    const dateOfAttendance: string = data?.attendance_date || '';

    const result = await deleteAttendanceData(personalInfoId, dateOfAttendance);

    if (result.statusCode === 200) {
      dispatch(getAttendanceTakenList(formatDate(attendanceDate!)));
      dispatch(getAttendanceHomeList(formatDate(attendanceDate!)));

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Attendance record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the attendance record.",
          life: 3000,
        });
      }
    }
  }


  const handleViewAttendance = (data: AttendanceHomeType) => {
    setSelectedAttendanceData(data);
    setShowAttendanceViewModal(true);
  };

  const attendanceViewModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title text-capitalize fs-5">
        {selectedAttendanceData &&
          selectedAttendanceData?.personalInfo?.first_name}&nbsp;
        {(selectedAttendanceData?.personalInfo?.last_name) ? selectedAttendanceData?.personalInfo?.last_name : ''}
      </h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseAttendanceViewModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const handleChangeAttendance = (
    e: CheckboxChangeEvent,
    personal_info_id: number,
    hasAttendance: boolean,
    employeeName: string,
    attendance: "Present" | "Absent" | "Halfday",
    employeeId: number
  ) => {

    if (!hasAttendance) {
      handleShowAlertModal();
      setAlertMessage(`Select the site before taking the attendance register of ${employeeName}.`);
      return;
    }

    setValueChanged(true);
    //   here actions build
    if (employeeId !== null) {
      // find selected employee id attendance data.
      const selectedlist = finalattendanceData.filter(
        (e) => e.contact_id === employeeId
      );

      if (selectedlist && selectedlist.length > 0) {
        const selectAttendance = selectedlist[0].attendanceData; // attendance info type data
        // this is modify attendance data.
        const attendanceDatax: any = {
          id: selectAttendance?.id,
          contact_id: selectAttendance?.contact_id,
          personal_info_id: personal_info_id,
          project_id: selectAttendance?.project_id,
          attendance_date: selectAttendance?.attendance_date,
          status: attendance,
          project_data: selectAttendance?.project_data,
        };

        const finalDataCollection: any = finalattendanceData?.map((element) => {
          if (employeeId === element.contact_id) {
            return {
              id: element.id,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              daily_hours: element.daily_hours,
              status: element.status,
              attendanceData: attendanceDatax,
              lastAttendanceData: element.lastAttendanceData,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };
          } else {
            return {
              id: element.id,
              contact_id: element.contact_id,
              personal_info_id: element.personal_info_id,
              daily_hours: element.daily_hours,
              status: element.status,
              attendanceData: element.attendanceData,
              lastAttendanceData: element.lastAttendanceData,
              personalInfo: element.personalInfo,
              userRoleInfo: element.userRoleInfo,
            };
          }
        });
        setFinalAttendanceData(mapAttendanceTakenTypes(finalDataCollection));
      }
    }
  };

  /* For table view */
  const employeeProfileImageBody = (rowData: AttendanceHomeType) => {
    const profileImage = rowData?.personalInfo?.profile_image;
    const firstName = rowData?.personalInfo?.first_name ? rowData?.personalInfo?.first_name : "";
    const lastName = rowData?.personalInfo?.last_name ? rowData?.personalInfo?.last_name : "";
    const profileNameLetters = firstName[0] + lastName[0];

    return (
      <div className="employee_profile_display">
        <div className="employee_profile_image">
          {profileImage !== null ? (
            <img src={baseURL + profileImage} alt="Employee" />
          ) : (
            <span>{profileNameLetters}</span>
          )}
        </div>
      </div>
    );
  };

  const employeeNameBody = (rowData: AttendanceHomeType) => {
    const firstName = rowData?.personalInfo?.first_name ? rowData?.personalInfo?.first_name : "";
    const lastName = rowData?.personalInfo?.last_name ? rowData?.personalInfo?.last_name : "";

    return (
      <span className="text_bold text-capitalize">
        {firstName + " " + lastName}
      </span>
    );
  };

  const attendanceBody = (rowData: AttendanceHomeType) => {
    const data = rowData;
    const attendanceStatus = data.status;

    return (
      <React.Fragment>
        <Tooltip
          key={`attendance_status_${data?.personal_info_id}`}
          id={`attendance_status_${data?.personal_info_id}`}
          target={`.attendance_status_${data?.personal_info_id}`}
        />

        <div className="status_icon_area">
          {attendanceStatus === "Present" ? (
            <i
              className={`attendance_status_${data?.personal_info_id} bi bi-check-circle-fill success`}
              data-pr-tooltip={`Present`}
              data-pr-position="top"
            ></i>
          ) : attendanceStatus === "Absent" ? (
            <i
              className={`attendance_status_${data?.personal_info_id} bi bi-dash-circle-fill warning`}
              data-pr-tooltip={`Absent`}
              data-pr-position="top"
            ></i>
          ) : attendanceStatus === "Halfday" ? (
            <i
              className={`attendance_status_${data?.personal_info_id} bi bi-check-circle`}
              data-pr-tooltip={`Halfday`}
              data-pr-position="top"
            ></i>
          ) : null}
        </div>
      </React.Fragment>
    );
  };

  const tableActionBody = (rowData: AttendanceHomeType) => {
    return (
      <div className="table_action_btn_area">
        {(siteFilter?.shared_by === null && siteFilter.address?.toLowerCase() !== "all sites share") && (
          <button
            className="table_action_btn p-ripple"
            onClick={() => handleDeleteAttendance(rowData)}
          >
            Delete
            <Ripple />
          </button>
        )}

        {(siteFilter?.shared_by === null && siteFilter.address?.toLowerCase() !== "all sites share") && (
          <button
            className="table_action_btn p-ripple"
            onClick={() => handleViewAttendance(rowData)}
          >
            View
            <Ripple />
          </button>
        )}

        {(siteFilter?.shared_by === null && siteFilter.address?.toLowerCase() !== "all sites share") && (
          <button
            className="table_action_btn p-ripple"
            onClick={() => handleViewPayment(rowData)}
          >
            Payment
            <Ripple />
          </button>
        )}
      </div>
    );
  };
  /*  */

  /* View attendance */
  const handleFilterEmployeeSite = (e: DropdownChangeEvent) => {
    const selectedSite = e.value as AttendanceProjectType;
    setSelectedEmployeeSiteId(selectedSite?.project_id || null);
    setEmployeeSiteFilter(selectedSite);
  };

  // this call and set data from api collections.

  // tigger action

  const singleEmployeeTakenList = useAppSelector(
    (state) => state.attendanceSingleEmployee.attendanceEmployeeList
  );

  useEffect(() => {
    if (singleEmployeeTakenList && singleEmployeeTakenList !== null) {
      setEmployeeAttendanceData(singleEmployeeTakenList!);
    }
  }, [singleEmployeeTakenList]);

  useEffect(() => {
    const list =
      employeeSiteFilter?.project_id === 0
        ? employeeAttendanceData?.full_list
        : employeeAttendanceData?.full_list?.filter(
          (e) => e.project_id === employeeSiteFilter?.project_id
        );
    if (list) {
      const dateStyles: Record<string, string> = {};
      list.forEach((entry) => {
        if (entry.attendance_date) {
          const formattedDate = new Date(entry.attendance_date).toDateString();
          let color = "";

          switch (entry.status) {
            case "Present":
              color = "#10CB10";
              break;
            case "Absent":
              color = "#F7B10D";
              break;
            case "Halfday":
              color = "#81878E";
              break;
          }

          dateStyles[formattedDate] = color;
        }
      });

      setHighlightedDates(dateStyles);
    }
  }, [employeeAttendanceData, employeeSiteFilter]);

  const dateTemplate = (dateMeta: {
    day: number;
    month: number;
    year: number;
    today: boolean;
    selectable: boolean;
  }) => {
    const fullDate = new Date(
      dateMeta.year,
      dateMeta.month,
      dateMeta.day
    ).toDateString();
    const backgroundColor = highlightedDates[fullDate] || "transparent";
    const color =
      (highlightedDates[fullDate] && "rgb(255, 255, 255)") ||
      "rgba(0, 0, 0, 0.8)";
    const fontWeight = (highlightedDates[fullDate] && "500") || "400";

    return (
      <div
        style={{
          backgroundColor,
          borderRadius: "8px",
          width: "2.3rem",
          height: "2.3rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color,
          fontWeight: fontWeight,
        }}
        className="date_grid_item"
      >
        {dateMeta.day}
      </div>
    );
  };

  /*  */
  /* *************************************************************************** */

  /* ***************************** Common function ***************************** */
  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  const handleViewPayment = (data: AttendanceHomeType) => {
    setPaymentSiteFilter(siteFilter);
    setSelectedAttendanceData(data);
    setStartDate(startOfMonth(new Date()));
    setEndDate(endOfMonth(new Date()));
    setShowPaymentModal(true);
  }

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedAttendanceData(null);
  }

  const paymentModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title text-capitalize fs-5">
        {selectedAttendanceData &&
          selectedAttendanceData?.personalInfo?.first_name}&nbsp;
        {(selectedAttendanceData?.personalInfo?.last_name) ? selectedAttendanceData?.personalInfo?.last_name : ''}
      </h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleClosePaymentModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const handleFilterSitePayment = (e: DropdownChangeEvent) => {
    const selectedSite = e.value as AttendanceProjectType;
    setPaymentSiteFilter(selectedSite);
  };

  const handleStartDateChange = (e: any) => {
    const date = e.value;
    setStartDate(date);
  }

  const handleEndDateChange = (e: any) => {
    const date = e.value;
    setEndDate(date);
  }

  // need to check tomorro
  useEffect(() => {
    const rs = async () => {
      setPamentViewLoading(true);
      const response = await getAttendanceByEmployeeServiceBetweenDates(
        selectedAttendanceData?.personal_info_id!,
        formatDate(startDate),
        formatDate(endDate)
      );
      if (response.status) {
        setPamentViewLoading(false);
        const res = mapEmployeeAttendanceType(response.body);

        setDisplayPayment(res);
        // return res;
      }
    }

    rs();

  }, [selectedAttendanceData, startDate, endDate])

  // disply values

  useEffect(() => {
    if (diplayPayment && diplayPayment.full_list!.length > 0) {
      const filerDatapayment: AttendanceSingleEmployeeType[] =
        paymentSiteFilter?.address?.toLowerCase() === "all sites"
          ? (diplayPayment.full_list ?? [])   // fallback []
          : (diplayPayment.full_list ?? []).filter(
            (e) => e.project_id === paymentSiteFilter?.project_id
          );

      // Reset values
      setDisplayPresentValue(0);
      setDisplayAbsentValue(0);
      setDisplayHalfDayValue(0);
      setDisplayTotalPayValue(0);

      // Reduce once for performance
      const totals = filerDatapayment.reduce(
        (acc, obj) => {
          acc.totalPay += obj.payed || 0;
          if (obj.status === "Present") acc.present += 1;
          if (obj.status === "Absent") acc.absent += 1;
          if (obj.status === "Halfday") acc.halfDay += 1;
          return acc;
        },
        { totalPay: 0, present: 0, absent: 0, halfDay: 0 }
      );

      setDisplayPresentValue(totals.present);
      setDisplayAbsentValue(totals.absent);
      setDisplayHalfDayValue(totals.halfDay);
      setDisplayTotalPayValue(totals.totalPay);
    }
  }, [diplayPayment, paymentSiteFilter]);




  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {(loadingPage && attendanceTakenLoading && initalLoading) ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            {location.pathname === "/attendance" ? (
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="main_heading">Attendance</h4>
                <button className="back_btn p-ripple" onClick={goBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Back
                  <Ripple />
                </button>
              </div>
            ) : (
              <div className="page_breadcrumb_area">
                <ul className="page_breadcrumb">
                  <li
                    className="page_breadcrumb_item has_link has_child"
                    onClick={() => navigate(-1)}
                  >
                    {mainProject &&
                      mainProject?.job_number + ": " + mainProject?.address}
                  </li>
                  <li className="page_breadcrumb_item active">Attendance</li>
                </ul>

                <button className="back_btn p-ripple" onClick={goBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Back
                  <Ripple />
                </button>
              </div>
            )}

            <div className="page_header_area has_input_filter mt-sm-3 mt-3">
              <div className="filter_option_group custom">
                <div className="filter_date_input_group">
                  <Calendar
                    key={`dateFilter`}
                    id="dateFilter"
                    value={dateFilter}
                    onChange={handleFilterDate}
                    dateFormat="dd M yy"
                    maxDate={today}
                    placeholder="Select date"
                    className="custom_date_input filter_date_input custom_width"
                    showIcon
                    iconPos="left"
                    icon="bi bi-calendar2-minus-fill"
                    readOnlyInput
                  />
                </div>

                <div className="filter_dropdown_group">
                  <Dropdown
                    key={`attendanceSite`}
                    id="attendanceSite"
                    disabled={mainProject !== null ? true : false}
                    value={siteFilter}
                    onChange={handleFilterProject}
                    options={sitesOptionData}
                    optionLabel="full_address"
                    itemTemplate={projectAddressOptionTemplate}
                    panelClassName="status_option_panel text-capitalize"
                    placeholder="Select site"
                    className="form_dropdown filter_dropdown text-capitalize"
                    filter
                    filterPlaceholder="Search here"
                    dropdownIcon={mainProject !== null}
                  />
                </div>
              </div>

              <div className="filter_input_group">
                <IconField iconPosition="right">
                  {employeeSearchKey === "" ? (
                    <InputIcon className="bi bi-search"></InputIcon>
                  ) : (
                    <InputIcon
                      className="bi bi-x-lg search_clear_icon"
                      onClick={() => setEmployeeSearchKey("")}
                    ></InputIcon>
                  )}

                  <InputText
                    id="employeeSearchKey"
                    value={employeeSearchKey}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setEmployeeSearchKey(e.target.value)
                    }
                    className="custom_form_input filter_input"
                    placeholder="Search employee"
                    type="search"
                  />
                </IconField>
              </div>
            </div>

            <div className="page_header_area has_data_tiles mt-sm-3 mt-3">
              <div className="data_tile_label_area">
                <div className="data_tile_label success">
                  <span className="data_tile_label_text">Present:&nbsp;</span>
                  <span>{String(presentCount).padStart(2, "0")}</span>
                </div>
                <div className="data_tile_label warning">
                  <span className="data_tile_label_text">Absent:&nbsp;</span>
                  <span>{String(absentCount).padStart(2, "0")}</span>
                </div>
                <div className="data_tile_label secondary">
                  <span className="data_tile_label_text">Halfday:&nbsp;</span>
                  <span>{String(halfdayCount).padStart(2, "0")}</span>
                </div>
                <div className="data_tile_label info">
                  <span className="data_tile_label_text">Total pay:&nbsp;</span>
                  <span>
                    {currencySymbol}&nbsp;
                    {String(totalPay.toFixed(2)).padStart(5, "0")}
                  </span>
                </div>
              </div>

              <div className="page_action_area">

                {/* share button here actions */}

                {(siteFilter?.shared_by === null) && ((siteFilter?.address?.toLowerCase() !== "all sites") && (siteFilter?.address?.toLowerCase() !== "all sites share")) && (
                  <button
                    className="add_data_link_btn custom p-ripple"
                    onClick={handleShareQuotation}
                  >
                    <i className="bi bi-share-fill"></i>
                    <span className="btn_text">Share</span>
                    <Ripple />
                  </button>
                )}

                {add_data && (siteFilter?.shared_by === null) && (siteFilter?.address?.toLowerCase() !== "all sites share") && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddAttendance}
                  >
                    <i className={`bi ${attendanceAdded === false ? 'bi-pencil-square' : 'bi-plus-circle'}`}></i>
                    <span>{attendanceAdded === false ? 'Edit' : 'Add'} attendance</span>
                    <Ripple />
                  </button>
                )}

                {add_employee && (siteFilter?.shared_by === null) && (siteFilter?.address?.toLowerCase() !== "all sites share") && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleNavigateEmployees}
                  >
                    <i className="bi bi-person"></i>
                    <span>Employee</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_main_content_section">
              {attendanceData && attendanceData?.length > 0 ? (
                <DataTable
                  value={filteredAttendanceData}
                  paginator
                  size="small"
                  rows={10}
                  emptyMessage="No data found!"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ minWidth: "50rem" }}
                  paginatorDropdownAppendTo={"self"}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  className="page_table p-0 p-sm-2"
                  rowHover
                  scrollable
                  loading={tableDataLoading}
                >
                  <Column
                    body={employeeProfileImageBody}
                    style={{ width: "10%" }}
                  ></Column>

                  <Column
                    header="Employee"
                    headerClassName="text_purple"
                    body={employeeNameBody}
                    style={{ width: "25%" }}
                  ></Column>

                  <Column
                    header="Designation"
                    headerClassName="text_purple"
                    body={(rowData: AttendanceHomeType) => (
                      <span className="text-capitalize">
                        {rowData?.userRoleInfo?.display_role_name
                          ? rowData?.userRoleInfo?.display_role_name
                          : "---"}
                      </span>
                    )}
                    style={{ width: "20%" }}
                  ></Column>

                  <Column
                    header="Project"
                    headerClassName="text_purple"
                    body={(rowData: AttendanceHomeType) => (
                      <span className="text-capitalize">
                        {rowData?.full_address ? rowData?.full_address : "---"}
                      </span>
                    )}
                    style={{ width: "25%" }}
                  ></Column>

                  <Column
                    body={attendanceBody}
                    style={{ width: "10%" }}
                  ></Column>

                  <Column
                    body={tableActionBody}
                    frozen
                    alignFrozen="right"
                  ></Column>
                </DataTable>
              ) : (
                <NoDataCreated message={`No data found`} />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Attendance modal */}
      <Dialog
        visible={showAttendanceModal}
        headerClassName="custom_modal_header"
        header={attendanceModalHeader}
        footer={attendanceModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_md"
        contentClassName="py-0"
        onHide={handleCloseAttendanceModal}
      >
        <div className="custom_modal_body pt-0">
          <div className="filter_header_area">
            <div className="row">
              <div className="col-12 col-sm-6">
                <div className="filter_input_grp mb-2 mb-sm-0">
                  <Calendar
                    key={`attendanceDate`}
                    id="attendanceDate"
                    value={attendanceDate}
                    onChange={handleDateChange}
                    dateFormat="yy-mm-dd"
                    maxDate={today}
                    placeholder="yyyy/mm/dd"
                    className="custom_date_input w-100"
                    readOnlyInput
                  />
                  <i className="bi bi-calendar2-fill"></i>
                </div>
              </div>

              <div className="col-12 col-sm-6">
                <div className="filter_input_grp mb-0">
                  <InputText
                    key={`attendanceSearchkey`}
                    id="attendanceSearchkey"
                    value={attendanceSearchkey}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setAttendanceSearchKey(e.target.value)
                    }
                    className="custom_form_input"
                    placeholder="Search employee here"
                    type={"search"}
                  />
                  {attendanceSearchkey ? (
                    <i
                      className="bi bi-x-lg data_search_input_clear"
                      onClick={() => setAttendanceSearchKey("")}
                    ></i>
                  ) : (
                    <i className="bi bi-search"></i>
                  )}
                </div>
              </div>
            </div>
          </div>

          {attendanceTakenLoading === true ? (
            <div className="loading_container pos_rel">
              <ProgressSpinner
                className="progresscircle custom"
                style={{ width: "50px", height: "50px", stroke: "#8953D7" }}
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration="1s"
              />
            </div>
          ) : (
            <React.Fragment>
              {/* here need to connect attendance data ass well. */}
              {attendanceAdded && (
                <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                  <Message
                    severity='info'
                    className="message_text w-100"
                    icon="bi bi-info-circle"
                    style={{ border: '1px solid', borderRadius: '8px' }}
                    text={`The last attendance record has been checked. Please check and save.`}
                  />
                </div>
              )}

              <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                {finalattendanceData && finalattendanceData?.length > 0 ? (
                  <div className="row">
                    {filteredSiteEmployeesData && filteredSiteEmployeesData?.length > 0 ? (
                      <div className="col-12">
                        {filteredSiteEmployeesData?.map((employee) => {
                          const employeeId = employee?.contact_id!;
                          const siteId: number | null = employee?.attendanceData?.project_id || null;
                          const hasAttendance: boolean = employee?.attendanceData ? true : false;
                          const employeeName: string = employee?.personalInfo?.first_name + " " + (employee?.personalInfo?.last_name !== null ? employee?.personalInfo?.last_name : "");

                          return (
                            <article
                              key={employeeId}
                              className="attendance_list_container"
                            >
                              <div className="attendance_list_header">
                                <div className="attendance_list_name_area">
                                  <InputSwitch
                                    checked={true}
                                    onChange={(e) => handleRemoveEmployeeAndAttendance(e.value, employee)}
                                    className="input_switch_sm"
                                  />

                                  <h6>
                                    {employee?.personalInfo?.first_name + " " + (employee?.personalInfo?.last_name !== null ? employee?.personalInfo?.last_name : "")}
                                  </h6>
                                </div>
                                <div className="attendance_address_area">
                                  {employee.attendanceData !== null ? (
                                    <p>
                                      {employee?.attendanceData?.project_data?.full_address}
                                    </p>
                                  ) : (
                                    <span>
                                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                                      Select site.
                                    </span>
                                  )}

                                  <button
                                    className="table_action_btn p-ripple"
                                    onClick={() => handleChangeSite(employeeId, siteId)}
                                  >
                                    {employee?.attendanceData !== null ? "Change" : "Select"}
                                    <Ripple />
                                  </button>
                                </div>
                              </div>

                              <hr className="list_divide_line" />

                              <div className="attendance_list_body">
                                {["Present", "Absent", "Halfday"].map((status) => (
                                  <div
                                    key={status}
                                    className="attendance_list_label"
                                  >
                                    <Checkbox
                                      inputId={`${status}-${employeeId}`}
                                      onChange={(e) =>
                                        handleChangeAttendance(
                                          e,
                                          employee.personal_info_id!,
                                          hasAttendance,
                                          employeeName,
                                          status as | "Present" | "Absent" | "Halfday",
                                          employeeId
                                        )
                                      }
                                      checked={
                                        employee?.attendanceData?.status === status
                                      }
                                      className={!employee?.attendanceData?.status ? 'danger' : ''}
                                    // disabled={employee?.attendanceData === null}
                                    />
                                    <label
                                      htmlFor={`${status}-${employeeId}`}
                                    >
                                      {status}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </article>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="col-12">
                        <div className="no_records_found no_footer">
                          <i className="bi bi-exclamation-circle me-1"></i>
                          No employee(s) found.
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="no_records_found no_footer">
                    <i className="bi bi-exclamation-circle me-1"></i>
                    No data found.
                  </div>
                )}
              </div>
            </React.Fragment>
          )}

          <div className="add_list_btn_area">
            <div className="attendance_list_label">
              <Checkbox
                onChange={(e) => handleChangeUseLastAttendanceRecord(e)}
                checked={isUseLastAttendanceRecord}
                inputId="useLastAttendanceRecord"
              />
              <label htmlFor="useLastAttendanceRecord">
                Use last record
              </label>
            </div>

            <button className={`add_data_btn p-ripple`} onClick={handleShowSiteEmployeeList}>
              <i className={`bi bi-person-fill-gear`}></i>
              Add / Remove Employee
              < Ripple />
            </button>
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Attendance view modal */}
      <Dialog
        visible={showAttendanceViewModal}
        headerClassName="custom_modal_header"
        header={attendanceViewModalHeader}
        dismissableMask
        contentClassName="pt-0"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseAttendanceViewModal}
      >
        {employeeAttendanceData && employeeAttendanceData !== null ? (
          <div className="custom_modal_body pt-0">
            <div className="filter_header_area">
              <div className="row">
                <div className="col-12">
                  <div className="filter_input_grp mb-2 mb-sm-3">
                    <Dropdown
                      key={`employeeSite`}
                      id="employeeSite"
                      value={employeeSiteFilter}
                      onChange={handleFilterEmployeeSite}
                      options={sitesOptionData.filter((r) => (r.address?.toLowerCase() !== "all sites share") &&
                        !shareProjectIds.includes(r?.project_id ?? -3))}
                      optionLabel="full_address"
                      panelClassName="status_option_panel text-capitalize"
                      placeholder="Select site"
                      className="form_dropdown text-capitalize"
                      filter
                      filterPlaceholder="Search here"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="data_tile_label_area custom">
                    <div className="data_tile_label success">
                      <span className="data_tile_label_text">
                        Present:&nbsp;
                      </span>
                      <span>
                        {employeeAttendanceData?.full_list
                          ? String(
                            employeeAttendanceData?.full_list?.filter(
                              (attendance) => attendance?.status === "Present"
                            )?.length
                          ).padStart(2, "0")
                          : "00"}
                      </span>
                    </div>
                    <div className="data_tile_label warning">
                      <span className="data_tile_label_text">
                        Absent:&nbsp;
                      </span>
                      <span>
                        {employeeAttendanceData?.full_list
                          ? String(
                            employeeAttendanceData?.full_list?.filter(
                              (attendance) => attendance?.status === "Absent"
                            )?.length
                          ).padStart(2, "0")
                          : "00"}
                      </span>
                    </div>
                    <div className="data_tile_label secondary">
                      <span className="data_tile_label_text">
                        Halfday:&nbsp;
                      </span>
                      <span>
                        {employeeAttendanceData?.full_list
                          ? String(
                            employeeAttendanceData?.full_list?.filter(
                              (attendance) => attendance?.status === "Halfday"
                            )?.length
                          ).padStart(2, "0")
                          : "00"}
                      </span>
                    </div>
                    <div className="data_tile_label info">
                      <span className="data_tile_label_text">
                        Total pay:&nbsp;
                      </span>
                      <span>
                        {currencySymbol}&nbsp;
                        {String(
                          employeeAttendanceData?.full_list
                            ?.reduce(
                              (sum, attendance) =>
                                sum + (attendance?.payed ?? 0),
                              0
                            )
                            .toFixed(2)
                        ).padStart(5, "0")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-1 pt-2 p-sm-4 pt-sm-1 pb-sm-2 w-100">
              <div className="row">
                <div className="col-12">
                  <div className="calendar_inline_view_container">
                    <Calendar
                      key={`attendanceCalendarView`}
                      inputId="employeeAttendanceDate"
                      value={employeeAttendanceDate}
                      onChange={() => { }}
                      className="calendar_inline_view"
                      inline
                      viewDate={viewDate}
                      onViewDateChange={(e) => setViewDate(e.value)}
                      dateTemplate={dateTemplate}
                    />
                  </div>
                </div>

                {employeeSiteFilter?.project_id === 0 && (
                  <div className="col-12">
                    <div className="attendance_summary_table_area">
                      <div className="table-responsive">
                        <table className="table attendance_summary_table">
                          <thead>
                            <tr>
                              <th className="address_column">Site address</th>
                              <th className="text-center">Present</th>
                              <th className="text-center">Absent</th>
                              <th className="text-center">Halfday</th>
                            </tr>
                          </thead>
                          {employeeAttendanceData?.table_data &&
                            employeeAttendanceData?.table_data?.length > 0 ? (
                            <tbody>
                              {employeeAttendanceData?.table_data?.map(
                                (data, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="text-capitalize">
                                        {data?.site_address}
                                      </td>
                                      <td className="text-center">
                                        {String(data?.present).padStart(2, "0")}
                                      </td>
                                      <td className="text-center">
                                        {String(data?.absent).padStart(2, "0")}
                                      </td>
                                      <td className="text-center">
                                        {String(data?.halfday).padStart(2, "0")}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-secondary text-center"
                                >
                                  No data found!
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="row mt-3">
            <div className="col-12">
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            </div>
          </div>
        )}
      </Dialog>
      {/*  */}

      {/* Share modal */}
      <ShareModal
        canEditOption={false}
        isOpen={showContactShareModal}
        loading={loading}
        sharedList={sharedList}
        projectContactIds={projectContactIds}
        onClose={handleCloseShareModal}
        onShare={shareDataFunction}
        title="Share Client Account"
      />
      {/*  */}


      {/* Attendance payment modal */}
      <Dialog
        visible={showPaymentModal}
        headerClassName="custom_modal_header"
        header={paymentModalHeader}
        dismissableMask
        contentClassName="pt-0"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleClosePaymentModal}
      >
        {pamentViewLoading ? (
          <div className="custom_modal_body pt-0">
            <PageLoader containerClassName="h-auto" />
          </div>
        ) : (
          <React.Fragment>
            {employeeAttendanceData && employeeAttendanceData !== null ? (
              <div className="custom_modal_body pt-0">
                <div className="filter_header_area">
                  <div className="row">
                    <div className="col-12">
                      <div className="filter_input_grp mb-2 mb-sm-3">
                        <Dropdown
                          key={`paymentSiteFilter`}
                          id="paymentSiteFilter"
                          value={paymentSiteFilter}
                          onChange={handleFilterSitePayment}
                          options={sitesOptionData.filter((r) => (r.address?.toLowerCase() !== "all sites share") &&
                            !shareProjectIds.includes(r?.project_id ?? -3))}
                          optionLabel="full_address"
                          panelClassName="status_option_panel text-capitalize"
                          placeholder="Select site"
                          className="form_dropdown text-capitalize"
                          filter
                          filterPlaceholder="Search here"
                        />
                      </div>
                    </div>

                    <div className="col-12 col-sm-6">
                      <div className="filter_input_grp mb-2 mb-sm-0">
                        <Calendar
                          key={`startDate`}
                          id="startDate"
                          value={startDate}
                          onChange={handleStartDateChange}
                          dateFormat="yy-mm-dd"
                          placeholder="yyyy/mm/dd"
                          className="custom_date_input w-100"
                          readOnlyInput
                        />
                        <i className="bi bi-calendar2-fill"></i>
                      </div>
                    </div>

                    <div className="col-12 col-sm-6">
                      <div className="filter_input_grp mb-2 mb-sm-0">
                        <Calendar
                          key={`endDate`}
                          id="endDate"
                          value={endDate}
                          onChange={handleEndDateChange}
                          dateFormat="yy-mm-dd"
                          placeholder="yyyy/mm/dd"
                          className="custom_date_input w-100"
                          readOnlyInput
                        />
                        <i className="bi bi-calendar2-fill"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-1 pt-2 p-sm-4 pt-sm-1 pb-sm-2 w-100">
                  <div className="col-12">
                    <div className="data_tile_label_area flex-column custom">
                      <div className="data_tile_label justify-content-between custom success">
                        <span className="data_tile_label_text">
                          Present:&nbsp;
                        </span>
                        <span>
                          {displayPresentValue
                            ? String(displayPresentValue).padStart(2, "0")
                            : "00"}
                        </span>
                      </div>
                      <div className="data_tile_label justify-content-between custom warning">
                        <span className="data_tile_label_text">
                          Absent:&nbsp;
                        </span>
                        <span>
                          {displayAbsentValue
                            ? String(
                              displayAbsentValue).padStart(2, "0")
                            : "00"}
                        </span>
                      </div>
                      <div className="data_tile_label justify-content-between custom secondary">
                        <span className="data_tile_label_text">
                          Halfday:&nbsp;
                        </span>
                        <span>
                          {displayHalfDayValue
                            ? String(displayHalfDayValue).padStart(2, "0")
                            : "00"}
                        </span>
                      </div>
                      <div className="data_tile_label justify-content-between custom info">
                        <span className="data_tile_label_text">
                          Total pay:&nbsp;
                        </span>
                        <span>
                          {currencySymbol}&nbsp;
                          {String(displayTotalPayValue?.toFixed()).padStart(2, "0")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row mt-3">
                <div className="col-12">
                  <div className="no_records_found no_footer">
                    <i className="bi bi-exclamation-circle me-1"></i>
                    No data found.
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </Dialog>
      {/*  */}


      {/* Site modal */}
      <Dialog
        visible={showSiteModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseSiteModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"siteSearchKey"}
                id="siteSearchKey"
                value={siteSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSiteSearchKey(e.target.value)
                }
                className="custom_form_input data_search_input"
                placeholder="Search site by job number/address"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {siteSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setSiteSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseSiteModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body">
            {filteredSitesData && filteredSitesData?.length > 0 ? (
              <React.Fragment>
                <div className="data_select_option_area">
                  {filteredSitesData.map((site) => (
                    <div
                      key={site?.project_id}
                      className={`data_select_option p-ripple ${selectedAttendanceEmployeeSiteId &&
                        site?.project_id === selectedAttendanceEmployeeSiteId ? "selected"
                        : ""
                        }`}
                      onClick={() => handleSelectSite(site)}
                    >
                      {site?.job_number + " - " + site?.full_address}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Site employee modal */}
      <Dialog
        visible={showEmployeeListModal}
        headerClassName="custom_modal_header"
        header={siteEmployeeListModalHeader}
        footer={siteEmployeeListModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_md"
        contentClassName="py-0"
        onHide={handleCloseSiteEmployeeListModal}
      >
        <div className="custom_modal_body">
          <div className="filter_header_area">
            <div className="row">
              <div className="col-12">
                <div className="filter_input_area">
                  <div className="filter_input_grp w-100 mb-0">
                    <InputText
                      key={`employeeListSearchKey`}
                      id="employeeListSearchKey"
                      value={employeeListSearchKey}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setEmployeeListSearchKey(e.target.value)
                      }
                      className="custom_form_input"
                      placeholder="Search employee here"
                      type={"search"}
                    />
                    {employeeListSearchKey ? (
                      <i
                        className="bi bi-x-lg data_search_input_clear"
                        onClick={() => setEmployeeListSearchKey("")}
                      ></i>
                    ) : (
                      <i className="bi bi-search"></i>
                    )}
                  </div>

                  <button
                    className="add_data_link_btn p-ripple radiused"
                    onClick={handleNavigateEmployees}
                  >
                    <span>Site Employees</span>
                    <i className="bi bi-box-arrow-up-right"></i>
                    <Ripple />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {loadingEmployeeList === true ? (
            <div className="loading_container pos_rel">
              <ProgressSpinner
                className="progresscircle custom"
                style={{ width: "50px", height: "50px", stroke: "#8953D7" }}
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration="1s"
              />
            </div>
          ) : (
            <React.Fragment>
              {siteEmployeesData && siteEmployeesData?.length > 0 ? (
                <DataTable
                  value={siteEmployeesData}
                  paginator
                  size="small"
                  rows={10}
                  emptyMessage="No data found!"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ maxWidth: "100%" }}
                  paginatorDropdownAppendTo={"self"}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  className="page_table auto_height p-0 p-sm-2"
                  scrollable={false}
                  rowHover
                >
                  <Column
                    header="Employee"
                    headerClassName="text_purple"
                    body={siteEmployeeNameBody}
                    style={{ width: "50%" }}
                    className="py-3"
                  ></Column>

                  <Column
                    header="Designation"
                    headerClassName="text_purple"
                    body={(rowData: SiteEmployeeType) => (
                      <span className="text-capitalize">
                        {rowData?.userRoleInfo?.display_role_name
                          ? rowData?.userRoleInfo?.display_role_name
                          : "---"}
                      </span>
                    )}
                    style={{ width: "30%" }}
                  ></Column>

                  <Column
                    header="Status"
                    headerClassName="text_purple"
                    alignHeader={"center"}
                    body={employeeStatusBody}
                    style={{ width: "20%" }}
                  ></Column>
                </DataTable>
              ) : (
                <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-4 w-100">
                  <NoDataCreated
                    containerClassname="pos_rel"
                    message={`No employee(s) found!`}
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </Dialog>
      {/*  */}

      {/* Alert modal */}
      <AlertModal
        isOpen={showAlertModal}
        onClose={handleCloseAlertModal}
        message={alertMessage}
      />
      {/*  */}

      {/* Show success message */}
      <div
        className={`message_backdrop ${showAlert ? "show" : ""}`}
        onClick={handleCloseAlert}
      >
        <div
          className={`message_box ${showAlert ? "show" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="message_box_content">
            <i className="bi bi-check-circle-fill message_box_icon"></i>
            <h6 className="message_box_message">{successMessage}</h6>
          </div>
        </div>
      </div>
      {/*  */}
    </React.Fragment >
  );
};

export default Attendance;
